import Article from '@/pages/article/Article.vue'
import ArticleDetail from '@/pages/article/ArticleDetail.vue'

// 资讯中心相关路由数组
export const articleRoutes = [
  {
    path: '/article',
    name: 'Article',
    component: Article,
    meta: {
      title: '资讯中心'
    }
  },
  {
    path: '/article/:id',
    name: 'ArticleDetail',
    component: ArticleDetail,
    meta: {
      title: '资讯详情'
    }
  }
]

export default articleRoutes



// WEBPACK FOOTER //
// ./src/router/article.js